import type {PermissionsRecordType} from '../permissions';

export const saleVehiclePermissions = {
  saleVehicleBackgroundRemoval: {
    resourceId: 'SALE_VEHICLE_PHOTO_ALBUM',
    actionId: 'REMOVE_PHOTOS_BACKGROUND',
    scopes: [],
  },
} satisfies PermissionsRecordType;
